function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .a {\n                fill: #175EA8;\n            }\n\n            .b,\n            .d {\n                fill: none;\n            }\n\n            .b {\n                stroke: #175EA8;\n                stroke-width: 1.5px;\n            }\n\n            .c {\n                stroke: none;\n            }\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1186 -115)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1191 123)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M221.774,67.766a7.483,7.483,0,0,0-2.871-1.885,4.709,4.709,0,0,0,1.13-6.358,4.246,4.246,0,0,0-6.072-1.183,4.709,4.709,0,0,0-1.13,6.358,4.474,4.474,0,0,0,1.13,1.183,7.907,7.907,0,0,0-5.083,7.479h.008a.674.674,0,0,0-.008.1h0a.666.666,0,0,0,.649.68h13.811a.666.666,0,0,0,.649-.68h0a.678.678,0,0,0-.008-.1h.008A8.047,8.047,0,0,0,221.774,67.766Zm-8.529-5.654a3.19,3.19,0,1,1,3.188,3.337A3.265,3.265,0,0,1,213.245,62.112Zm3.188,4.573a6.506,6.506,0,0,1,6.349,6.1h-12.7a6.506,6.506,0,0,1,6.348-6.1Z",
  transform: "translate(-202.88 -57.537)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M204.137,104.918a.6.6,0,0,0,.641-.055l2.354-1.766a.612.612,0,0,0,0-.978l-2.355-1.766a.612.612,0,0,0-.978.489v1.095l-.287-.016c-.8-.044-1.491-.1-2.114-.168-5.418-.558-7.856-1.9-7.856-2.677,0-.366.643-1.007,2.456-1.61a.617.617,0,0,0,.493-.6.6.6,0,0,0-.259-.482.643.643,0,0,0-.376-.126.56.56,0,0,0-.173.027c-2.232.73-3.364,1.67-3.364,2.794,0,2.755,6.849,3.676,8.949,3.893.689.076,1.453.136,2.273.18l.257.014v1.211A.6.6,0,0,0,204.137,104.918Z",
  transform: "translate(-192.321 -82.986)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M239.983,102.479a.616.616,0,0,0,.664.558c2.292-.193,9.781-1.051,9.781-3.966,0-1.125-1.134-2.066-3.37-2.794a.612.612,0,1,0-.379,1.164c1.863.606,2.526,1.24,2.526,1.632,0,.816-2.754,2.253-8.664,2.747A.614.614,0,0,0,239.983,102.479Z",
  transform: "translate(-223.428 -82.98)"
}))));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  className: "b"
}, /*#__PURE__*/React.createElement("rect", {
  className: "c",
  width: 37,
  height: 37,
  rx: 8
}), /*#__PURE__*/React.createElement("rect", {
  className: "d",
  x: 0.75,
  y: 0.75,
  width: 35.5,
  height: 35.5,
  rx: 7.25
}));

var SvgChangeSupplier = function SvgChangeSupplier(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChangeSupplier, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/change-supplier.3db2250b.svg";
export { ForwardRef as ReactComponent };